import { utcDatePrefix } from './utc-date-prefix';

/**
 * Renders the UTC calendar day of a `Date` as `DD-MM-YYYY` — the format the
 * date-picker trigger displays once a day is selected.
 *
 * Spartan's default `formatDate` is `Date.prototype.toDateString()`, which
 * yields `Tue Aug 04 2026`: English weekday and month names, and a component
 * order this panel does not use.
 *
 * Built on `utcDatePrefix()` so both the DISPLAYED day and the day PERSISTED in
 * the model are read from the same UTC getters. Local getters would shift the
 * displayed day by one on machines whose offset crosses midnight relative to
 * the instant, making the trigger disagree with the stored value.
 *
 * @param date A `Date` object whose UTC components represent the chosen day.
 * @returns The day formatted as `DD-MM-YYYY`.
 *
 * @example
 * formatUtcDate(new Date(Date.UTC(2026, 7, 18))); // → '18-08-2026'
 */
export function formatUtcDate(date: Date): string {
  const [year, month, day] = utcDatePrefix(date).split('-');
  return `${day}-${month}-${year}`;
}
